
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/page/plan-your-visit",
      function () {
        return require("private-next-pages/[locale]/page/plan-your-visit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/page/plan-your-visit"])
      });
    }
  